import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=f83bc2a8&scoped=true&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83bc2a8",
  null
  
)

export default component.exports